export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'xiazai-jiaocheng',
    name: '下载教程',
    description: '哔咔漫画下载安装全攻略，覆盖安卓、iOS等各平台详细教程',
    icon: 'ri-download-cloud-2-line',
  },
  {
    slug: 'zhuce-zhinan',
    name: '注册指南',
    description: '哔咔漫画账号注册与登录流程详解，快速开启漫画之旅',
    icon: 'ri-user-add-line',
  },
  {
    slug: 'gongneng-tese',
    name: '功能特色',
    description: '探索哔咔漫画强大的阅读功能和个性化设置',
    icon: 'ri-star-line',
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '哔咔漫画使用过程中的常见疑问与解决方案汇总',
    icon: 'ri-question-answer-line',
  },
  {
    slug: 'shiyong-jiqiao',
    name: '使用技巧',
    description: '哔咔漫画高手进阶技巧，让你的阅读体验更加畅快',
    icon: 'ri-lightbulb-line',
  },
];